import { PageActions } from '@e3dc-react/shell/State/App/AppModel'
import { isEqual } from 'lodash'
import React, { useCallback, useMemo, useState } from 'react'
import PageActionsContext, { PageActionsContextProps } from './page-actions.context'

interface Props {
  children: React.ReactNode
}

/**
 * Provider to get and set the page actions for the header.
 *
 * Caution! If a component does not use the useSelectedUserRoutes it seems that the pageActions are not set.
 */
export const PageActionsProvider: React.FC<Props> = ({ children }) => {
  const [pageActions, setPageActions] = useState<PageActions>([])

  const dispatchPageActions = useCallback((value: PageActions): void => {
    setPageActions(prevPageActions => {
      if (!isEqual(prevPageActions, value)) {
        return value
      }
      return prevPageActions
    })
  }, [])

  const value = useMemo(() => ({ dispatchPageActions, pageActions }), [dispatchPageActions, pageActions])

  return <PageActionsContext.Provider value={value}>{children}</PageActionsContext.Provider>
}

export const usePageActionsContext = (): PageActionsContextProps => React.useContext(PageActionsContext)
